import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../../utils/dom';
import s from './Table.scss';

const Table = ({ content }) => (
	<div className={s.table} dangerouslySetInnerHTML={{ __html: purifier(content.rawText) }} />
);

export default hot(module)(Table);
